module.exports = __webpack_public_path__ + "img/type-1.df137c66.svg";